<div class="mt-5 flex lg:ml-4 lg:mt-0">
	<ng-content />
</div>
